<template>
	<div class="current-alarms">
		<template v-if="!isEmpty(types)">
			<v-card
				v-for="(alarms, alarm_type) in types"
				:key="alarm_type"
				class="alarm-box"
				elevation="1"
				tile
			>
				<v-card-title class="justify-center text-break">
					{{ deviceAlarmType({ alarm_type }) }}
				</v-card-title>
				<v-card-text
					v-for="alarm in alarms"
					:key="alarm.id"
					class="ticket-status"
				>
					<div class="status-row flex-sm-row align-sm-center">
						<div class="status-col flex-sm-column align-sm-start col-sm-2">
							<span class="status-key d-sm-none">Device</span>
							<v-tooltip top>
								<template #activator="{ on, attrs }">
									<span
										class="status-val"
										v-bind="attrs"
										v-on="on"
										v-text="deviceAlarm(alarm)"
									/>
								</template>
								<span v-text="valueText(alarm)" />
							</v-tooltip>
						</div>
						<div class="status-col flex-sm-column col-sm-3">
							<span class="status-key d-sm-none">Status</span>
							<StatusSelect
								class="status-val"
								:status="alarm.alarm_status"
								:severity="alarm.severity"
								@select="$emit('change-status', $event, alarm)"
							/>
						</div>
						<div class="status-col flex-sm-column col-sm-2">
							<span class="status-key d-sm-none">Severity</span>
							<div>
								<v-tooltip top>
									<template #activator="{ on, attrs }">
										<span class="status-val" v-bind="attrs" v-on="on">
											{{ capitalize(alarm.severity) }}
											<v-icon small>fa fa-circle-info</v-icon>
										</span>
									</template>
									<span>{{ getDescription(alarm) }}</span>
								</v-tooltip>
							</div>
						</div>
						<div class="status-col flex-sm-column col-sm-4">
							<span class="status-key d-sm-none">Triggered</span>
							<span class="status-val" v-text="fullDateTime(alarm.ts)" />
						</div>
						<v-tooltip top :disabled="hasFixSteps(alarm.alarm_type)">
							<template #activator="{ on, attrs }">
								<div
									class="status-col flex-sm-column justify-center col-sm-1"
									v-bind="attrs"
									v-on="on"
								>
									<v-btn
										text
										small
										color="primary"
										:disabled="!hasFixSteps(alarm.alarm_type)"
										@click="$emit('fix', alarm)"
									>
										<v-icon class="mr-1" small
											>fa-solid fa-screwdriver-wrench</v-icon
										>
										<span>Fix</span>
									</v-btn>
								</div>
							</template>
							<span>Please contact K4Support for help with this issue.</span>
						</v-tooltip>
					</div>
				</v-card-text>
			</v-card>
		</template>
	</div>
</template>

<script>
import _ from "lodash";
import deviceHelpers from "./deviceHelpers";
import { descriptions } from "./status";
import { fullDateTime } from "@/utils/dateHelpers";
import { mapGetters } from "vuex";

export default {
	components: {
		StatusSelect: () => import("./StatusSelect.vue"),
	},
	props: {
		types: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		...mapGetters({
			hasFixSteps: "tickets/fixWizard/hasFixSteps",
		}),
	},
	methods: {
		...deviceHelpers,
		fullDateTime,
		capitalize: _.capitalize,
		isEmpty: _.isEmpty,

		getDescription(item) {
			return _.get(descriptions[item.alarm_type], item.severity, "");
		},
	},
};
</script>

<style lang="scss" scoped>
@import "./InputHeaderTable.scss";
</style>
